import { MessageCircle } from "lucide-react";

function StatisticQuestion({ statisticQuestions }) {
  // console.log(statisticQuestions, "gelen istatitik soru");

  if (!statisticQuestions || !Array.isArray(statisticQuestions)) {
    return null;
  }

  // Doğru/yanlış sayısını hesapla (varsa)
  const correctAnswers = statisticQuestions.filter(
    (q) => q.isCorrect === true,
  ).length;
  const totalQuestions = statisticQuestions.length;
  const successRate =
    totalQuestions > 0
      ? ((correctAnswers / totalQuestions) * 100).toFixed(0)
      : 0;

  return (
    <div className="space-y-4">
      <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-xl p-4 border border-purple-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-white p-2 rounded-lg shadow-sm">
              <MessageCircle className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h4 className="text-base font-bold text-gray-800">
                Soru İstatistikleri
              </h4>
              <p className="text-xs text-gray-600">
                Toplam {totalQuestions} soru
              </p>
            </div>
          </div>

          {totalQuestions > 0 && (
            <div className="text-right">
              <p className="text-xs text-gray-600 mb-1">Başarı Oranı</p>
              <div className="flex items-center gap-2">
                <div className="w-16 h-16 rounded-full bg-white shadow-md flex items-center justify-center border-4 border-purple-400">
                  <span className="text-xl font-bold text-purple-600">
                    {successRate}%
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="grid gap-3">
        {statisticQuestions.map((question, index) => {
          const isCorrect = question.isCorrect;

          return (
            <div
              key={index}
              className={`rounded-xl p-4 border-2 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] ${
                isCorrect === true
                  ? "bg-gradient-to-br from-green-50 to-emerald-50 border-green-300"
                  : isCorrect === false
                    ? "bg-gradient-to-br from-red-50 to-rose-50 border-red-300"
                    : "bg-gradient-to-br from-gray-50 to-slate-50 border-gray-300"
              }`}
            >
              <div className="flex items-start gap-3">
                <div
                  className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${
                    isCorrect === true
                      ? "bg-green-500 text-white"
                      : isCorrect === false
                        ? "bg-red-500 text-white"
                        : "bg-gray-400 text-white"
                  }`}
                >
                  {isCorrect === true
                    ? "✓"
                    : isCorrect === false
                      ? "✗"
                      : index + 1}
                </div>

                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-bold text-gray-500 uppercase tracking-wide">
                      Soru {index + 1}
                    </span>
                    {isCorrect !== undefined && (
                      <span
                        className={`text-xs font-semibold px-2.5 py-1 rounded-full ${
                          isCorrect
                            ? "bg-green-200 text-green-800"
                            : "bg-red-200 text-red-800"
                        }`}
                      >
                        {isCorrect ? "Doğru Cevap" : "Yanlış Cevap"}
                      </span>
                    )}
                  </div>

                  {question.question && (
                    <p className="text-sm font-medium text-gray-800 mb-3 leading-relaxed">
                      {question.question}
                    </p>
                  )}

                  {question.userAnswer && (
                    <div className="bg-white bg-opacity-60 rounded-lg p-2.5 border border-gray-200">
                      <div className="flex items-start gap-2">
                        <span className="text-xs font-semibold text-gray-500 mt-0.5">
                          Cevap:
                        </span>
                        <span className="text-sm font-semibold text-gray-900">
                          {question.userAnswer}
                        </span>
                      </div>
                    </div>
                  )}

                  {question.correctAnswer &&
                    question.correctAnswer !== question.userAnswer && (
                      <div className="mt-2 bg-green-100 bg-opacity-60 rounded-lg p-2.5 border border-green-200">
                        <div className="flex items-start gap-2">
                          <span className="text-xs font-semibold text-green-700 mt-0.5">
                            Doğru Cevap:
                          </span>
                          <span className="text-sm font-semibold text-green-900">
                            {question.correctAnswer}
                          </span>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {totalQuestions === 0 && (
        <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-300">
          <MessageCircle className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-500 font-medium">
            Henüz soru istatistiği bulunmuyor
          </p>
        </div>
      )}
    </div>
  );
}
export default StatisticQuestion;
